const shallowCompareObjects = (a, b, excludedKeys) => {
  if (!excludedKeys) {
    excludedKeys = [];
  }
  // primitive
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  // check num keys b could have more keys than a
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }

  // remove excluded keys from the comparison set
  const compareKeys = Object.keys(a).filter((key) => {
    if (excludedKeys.indexOf(key) < 0) {
        return true;
    }

    return false;
  });

  // check values
  for (let i = 0; i < compareKeys.length; i++) {
    const key = compareKeys[i];

    if(a[key] !== b[key]) {
      return false;
    }
  }

  // same
  return true;
};

const shallowCompareObjectsByKey = (a, b, keyArray) => {
  for (let i = 0; i < keyArray.length; i++) {
    const key = keyArray[i];

    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
};

const shallowCompareArrays = (a, b) => {
  // b should not be larger than a
  if (a.length !== b.length) {
    return false;
  }

  // check values
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  // same
  return true;
};

// checks arrays / objects contain same values
// - not dependent on order / keys
// - is dependent on count of each value
const shallowCompareObjectsSameValues = (a, b) => {
  const aMap = new Map();
  const bMap = new Map();

  // create map of <value-count> in a
  Object.values(a).forEach(aVal => {
    if (!aMap.has(aVal)) {
      aMap.set(aVal, 0);
    }

    const aMemoCount = aMap.get(aVal);
    aMap.set(aVal, aMemoCount + 1);
  });

  // create map of <value-count> in b
  Object.values(b).forEach(bVal => {
    if (!bMap.has(bVal)) {
      bMap.set(bVal, 0);
    }

    const bMemoCount = bMap.get(bVal);
    bMap.set(bVal, bMemoCount + 1);
  });

  let isEqual = true;
  // check that each value in a is in bMap
  aMap.forEach((aCount, aVal) => {
    if (!bMap.has(aVal)) {
      isEqual = false;
    }
  });

  // check that each value in b is in aMap, and has same count.
  bMap.forEach((bCount, bVal)  => {
    if (!aMap.has(bVal)) {
      isEqual = false;
    } else if (aMap.get(bVal) !== bCount) {
      isEqual = false;
    }
  });

  return isEqual;
};

const deepEqual = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];
    const areObjs = isObject(val1) && isObject(val2);

    if (areObjs && !deepEqual(val1, val2) || !areObjs && val1 !== val2) {
      return false;
    }
  }

  return true;
};

const isObject = (obj) => (obj !== null && typeof obj === 'object');

const compareChildren = (currChildren, nextChildren) => {
  if (currChildren.length !== nextChildren.length) return false;

  for (let i = 0; i < nextChildren.length; i++) {
    if (!shallowCompareObjects(currChildren[i], nextChildren[i]))
      return false;
  }

  return true;
};

export {
  deepEqual,
  shallowCompareObjects,
  shallowCompareObjectsByKey,
  shallowCompareArrays,
  shallowCompareObjectsSameValues,
  compareChildren,
};
